import {combineReducers} from "redux";
import auth from "./auth";
import actions from "./actions";
import linking from "./linking";
export default combineReducers({
  auth,
  actions,
  linking,
});
